import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalize',
    standalone: true,
})
export class CapitalizePipe implements PipeTransform {
    public transform(value: string): string {
        // capitalize only the first letter
        return value[0].toUpperCase() + value.slice(1);
    }
}
